import React, { Fragment, useEffect, useState } from 'react';
import * as NoteService from '../Services/NoteService';
import Header from './Heading';


export default function ShowNotes({ identifier }) {
    const [notes, setNotes] = useState(null);

    useEffect(() => {
        console.log(identifier);
        NoteService.getNotes(identifier).then((a) => {
            console.log(a);
            setNotes(a);
        });
    }, []);

    return <div className="grid justify-items-center">
        <Header text={"Notes"} type="h1" />
        {notes && <table className="table-auto max-w-full border-collapse border border-slate-500">
            <thead>
                <tr>
                    <th className="border border-slate-600">Message</th>
                    <th className="border border-slate-600">By</th>
                    <th className="border border-slate-600">Links</th>
                    <th className="border border-slate-600">timestamp</th>
                </tr>
            </thead>
            <tbody>
                {notes.map(n => (
                    <tr key={n.timestamp}>
                        <td className="border border-slate-600">{n.message}</td>
                        <td className="border border-slate-600">{n.updatedBy}</td>
                        <td className="border border-slate-600">{n.links ? n.links.map(l =>
                            <Fragment key={l}>
                                <a href={l}>Record</a><br />
                            </Fragment>) : "No links"}
                        </td>
                        <td className="border border-slate-600">{new Date(n.timestamp).toLocaleDateString("en-US")}</td>
                    </tr>
                ))}
            </tbody>
        </table>}
    </div>
}